import { createApp } from 'vue'
import 'amfe-flexible'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from './store'
import router from './route/index.js'
import cookies from 'vue-cookies'
import App from './App.vue'
import axios from 'axios'
import Vant from 'vant'
import '@/assets/css/common.less'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import 'vant/lib/index.css'
import './uitils/style'


axios.get("./../config.json", { headers: { "Cache-Control": "no-cache" } }).then(res => {
  localStorage.setItem('ApiUrl', res.data.url);
}).catch((error) => { console.log(error) });

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 获取屏幕高度
app.config.globalProperties.windowHeight = () => {
  return window.innerHeight
}
app.use(ElementPlus)
app.use(store)
app.use(router)
app.use(cookies)
app.use(Vant)
app.mount('#app')
app.config.globalProperties.$Message = app.config.globalProperties.$message;
app.config.globalProperties.$Confirm = app.config.globalProperties.$comfirm;
//全局遮罩层点击阻止关闭弹窗
app._context.components.ElDialog.props.closeOnClickModal.default = false
//全局弹窗可以拖拽
app._context.components.ElDialog.props.draggable.default = true